<style scoped>
.vector svg {
	height: 100%
}
</style>

<template>
	<div class="vector" v-once v-html="src"></div>
</template>

<script>
	// see vue-loader.conf
	export default {
		props: ["src"]
	}
</script>



// WEBPACK FOOTER //
// vector.vue?eb911d3a